<div class="container-fluid p-0">
  <!-- <div class="col-md-12 pt-8">
    <span class="col-md-12 pull-left pl-7"> -->
  <form [formGroup]="dashboard" (ngSubmit)="SubmitForm()" class="row form-inline">
    <!-- removed class 'pull-left' and 'mr-10'  -->
    <!-- <span class="pt-5 label-std control-label b-600 w-auto">Client List</span> -->
    <div class="form-group col-md-3 mb-3 mt-3 mr-0 p-0">
      <label for="" class="formLabel">Client List &nbsp; </label>
      <app-common-dropdown-search [data]="ClientList" [addFieldSetting]="addFieldSetting" (callEvent)="onClientChange($event)"></app-common-dropdown-search>
      <!-- <select class="form-control" (change)="onClientChange($event)" formControlName="ClientId" [(ngModel)]="ClientId"
        placeholder="d.ff">
        <option [selected]="ClientList.length >1" disabled>Select</option>
        <option *ngFor="let Client of ClientList" [value]="Client.Client_Id" [selected]="Client.selected">
          {{Client.Client_Name}}
        </option>
      </select> -->
    </div>
    <!--  configdetail FORM-->
    <form *ngIf="showfields" [formGroup]="configdetail" (ngSubmit)="SubmitForm1()" class="form-inline">
      <div class="form-group">
        <label for="" class="formLabel p-0">Client Name &nbsp; </label>
        <input type="text" class="form-control" id="Client_Name" disabled placeholder="" [(ngModel)]="Client_Name"
          formControlName="Client_Name">
      </div>
      <div class="form-group">
        <label for="" class="formLabel p-0">Supervisor Name &nbsp; </label>
        <input type="text" class="form-control" id="Supervisor_Name" disabled placeholder=""
          [(ngModel)]="Supervisor_Name" formControlName="Supervisor_Name">
      </div>
      <div class="form-group">
        <label class="custom-control client-conf pt-2">
          <input type="checkbox" formControlName="isChecked" id="ac-active" (change)="function($event)"
            [(ngModel)]="isChecked">
          <label for="ac-active" class="">Is Active</label>
        </label>
      </div>

      <div class="col-md-1 text-center p-0">
        <!-- data-toggle="modal" data-target=".skip-ac" -->
        <button type="submit" [disabled]="DisableSubmit"
          class="btn blue square-btn blue-hover btn-txt mr-10 btn-default">Update</button>
      </div>

    </form>

    <div class="supervisorList" *ngIf="show">
      <div class="row">
        <div class="col-md-12">
          <h3>Supervisor List</h3>
        </div>
        <div class="col-md-12 row checkBoxList">
          <div class="col-md-2 mb-1" *ngFor="let j of SupervisorList; let k = index;">
            <label class="custom-control">
              <input type="checkbox" id="{{k}}" [checked]=" ( j.old == true )" (click)="changeCheckbox(k,$event)"
                formControlName="vals" />
              <label for="{{k}}">{{j.Full_Name}}</label>
            </label>
          </div>
          <div class="col-md-12" *ngIf="SupervisorList && SupervisorList.length==0">
            <h4>No supervisor list found</h4>
          </div>
        </div>
        <div class="col-md-12 mh-15" style="margin-top: 1rem;">

          <!-- data-toggle="modal" data-target=".skip-ac" -->
          <button style="float: center;" type="submit" [disabled]="DisableSubmit || SupervisorList.length==0"
            class="btn blue square-btn blue-hover btn-txt mr-10 btn-default" (click)="getFinalSelectedClient()">Submit</button>

        </div>
      </div>

    </div>
    <!-- <div *ngIf="showfields" class="container-fluid p-0">
      <div class="row">
        <form [formGroup]="configdetail" (ngSubmit)="SubmitForm1()" class="form-inline">
          <div class="form-group">
            <label for="" class="formLabel">Client Name &nbsp; </label>
            <input type="text" class="form-control" id="Client_Name" disabled placeholder="" [(ngModel)]="Client_Name"
              formControlName="Client_Name">
          </div>
          <div class="form-group">
            <label for="" class="formLabel p-0">Client List &nbsp; </label>
            <input type="text" class="form-control" id="Supervisor_Name" disabled placeholder=""
              [(ngModel)]="Supervisor_Name" formControlName="Supervisor_Name">
          </div>
          <div class="form-group">
            <label class="custom-control client-conf pt-2">
              <input type="checkbox" formControlName="isChecked" id="ac-active" (change)="function($event)"
                [(ngModel)]="isChecked">
              <label for="ac-active" class="">Is Active</label>
            </label>
          </div>

          <div class="col-md-1 text-center p-0">
            <button type="submit" [disabled]="DisableSubmit"
              class="btn blue square-btn blue-hover btn-txt mr-10">Update</button>
          </div>

        </form>
      </div>
    </div> -->

    <div class="col-md-12 col-xs-12 userlist-stickytable">
      <div class="col-md-12 col-sm-12 p-0">
        <div class="heading-panel sT-hight p-0">
          <span class="text-sm text-ellipsis heading-txt t-uppercase blue-text">Citra Employee Mapping</span>
          <div class="right-most">Total Rows:- <b>{{rowData == null ? '0' : rowData.length}}</b></div>
        </div>
      </div>
      <div class="col-md-20 col-sm-20 p-0">
        <div class="table-responcive">

          <div class="sticky-table-new sticky-ltr-cells border-0 table-hight">
            <ag-grid-angular [enableColResize]="true" [enableSorting]="true" [enableFilter]="true" [pagination]="true"
              [paginationPageSize]="15" class="ag-theme-balham grid-w" [rowData]="rowData" [columnDefs]="columnDefs"
              (cellClicked)='onCellClicked($event)' [suppressDragLeaveHidesColumns]="true"
              [suppressColumnVirtualisation]="true" [rowSelection]="rowSelection" (gridReady)="onGridReady($event)">
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
